export default "__VITE_ASSET__of9J9B3M__"